import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import useAuthStore from '../stores/useAuthStore';
import { Button, Nav } from 'react-bootstrap';

export default function AppNavBar() {

  const user = useAuthStore((state) => state.user)
  const session = useAuthStore((state) => state.session)
  const checkSession = useAuthStore((state) => state.checkSession)
  const logout = useAuthStore((state) => state.logout)


  return (
    <Navbar expand="lg" className="custom-navbar">
      <Container>
        <Navbar.Brand >
          Eternum
        </Navbar.Brand>
        <Navbar.Toggle />
        <Navbar.Collapse className="justify-content-end">
          <Nav className="align-items-center gap-3">
            <Navbar.Text>
              {/* Signed in as: <a href="#login">{user?.email}</a> */}
              Signed in as: {user?.email}

            </Navbar.Text>

            <Button variant="danger" onClick={logout}>
              Logout
            </Button>
            {/* <Nav.Link onClick={logout}>Logout</Nav.Link> */}

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
